import { makeStyles } from "tss-react/mui";
import React, { Dispatch, MutableRefObject, SetStateAction } from "react";
import { parseJSClassName } from "../JSClasses";
import { Box, Button } from "@mui/material";
import TranslationWrapper from "../../../../../../components/TranslationWrapper/TranslationWrapper";
import { LabeledBadge } from "../JamezzStylesComponent";
import EditIcon from "@mui/icons-material/Edit";
import { JSClassParameter } from "../../../../../../components/LiveInterfaceCustomComponents/LiveInterface";

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()({
  /**
   * Live interface styles
   **/
  liveInterfaceContent: {
    display: "flex",
    justifyContent: "space-around",
    overflowX: "hidden",
    overflowY: "scroll",
    height: "95vh",
    flexWrap: "wrap",
    padding: "16px",
    "&::-webkit-scrollbar": {
      width: 8,
      height: 8,
      borderRadius: 4,
    },
    "&::-webkit-scrollbar-track-piece": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(53,57,71,0.3)",
      width: 6,
      height: 6,
      borderRadius: 4,
    },
  },
  liveInterfaceMaps: {
    flex: 1,
    minWidth: 200,
    overflowX: "hidden",
    overflowY: "auto",
    maxHeight: "100%",
    marginLeft: 25,
    "&::-webkit-scrollbar": {
      width: 8,
      height: 8,
      borderRadius: 4,
    },
    "&::-webkit-scrollbar-track-piece": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(53,57,71,0.3)",
      width: 6,
      height: 6,
      borderRadius: 4,
    },
  },
  liveInterfaceIframe: {
    borderRadius: 5,
    border: "none",
  },
  liveInterfaceButton: {
    position: "absolute",
    left: 40,
    transition: "translate 0.2s",
    borderRadius: "0px 50px 50px",
    color: "white",
    border: "0px solid white",
    zIndex: 1000,
    padding: 10,
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  },
  liveInterfaceLoader: {
    width: 400,
    height: 600,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

export function postMessageToIframe(
  type: "addNewHoveredClass" | "removeNewHoveredClass" | "initReload" | "init" | "updateStyling",
  rest: Record<string, unknown> = {}
) {
  const iframe = document.getElementById("liveInterfaceIframe") as HTMLIFrameElement;
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage({ type, ...rest }, "*");
  } else {
    console.warn("Could not send message to iframe");
  }
}

export type HoverCardPositions = {
  hoveredValues: JsClasses;
  hoveredAvailableParameters: JSClassParameter[];
  hoveredWidth: number;
  hoveredHeight: number;
  mouseY: number;
  hoveredLeftSpacing: number;
  hoveredTopSpacing: number;
};

export function HoverCard({
  selectedClassNamesHaveEditsAvailable,
  hoverCard,
  iframeref,
  setSelectedGroup,
  contentDescription,
  hoverCardHidden,
  hoveredRoots,
}: {
  selectedClassNamesHaveEditsAvailable: boolean;
  hoverCard: HoverCardPositions;
  iframeref: MutableRefObject<HTMLIFrameElement | null>;
  setSelectedGroup: Dispatch<SetStateAction<string>>;
  contentDescription: string[];
  hoverCardHidden: boolean;
  hoveredRoots: JsClasses[];
}) {
  const { classes } = useStyles();
  let groups: string[];
  {
    const groupSet = new Set<string>();
    groupSet.add(parseJSClassName(hoverCard.hoveredValues[0] ?? "").group);
    hoveredRoots.forEach((hovered) => {
      hovered.forEach((cls) => {
        groupSet.add(parseJSClassName(cls).group);
      });
    });

    groups = Array.from(groupSet);
  }

  return (
    <div
      className={classes.liveInterfaceButton}
      id={"liveInterfaceButton"}
      style={{
        transition: "transform 0.1s ease-in, translate 0.1s ease-in, top 0.1s ease-in",
        position: "absolute",
        translate: `${hoverCard.hoveredLeftSpacing + hoverCard.hoveredWidth + 30}px`,
        top: (iframeref.current?.getBoundingClientRect().top ?? 0) + hoverCard.mouseY - 10 + "px",
        backgroundColor: "#E76D1A",
        display: "flex",
        flexDirection: "column",
        gap: 20,
        padding: 20,
        ...(hoverCardHidden
          ? {
              transform: "rotate3d(0, 1, 0, 90deg)",
            }
          : {}),
      }}
    >
      <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
        {groups.length > 0 ? (
          <Button
            disabled={!selectedClassNamesHaveEditsAvailable}
            onClick={() => {
              console.log(groups);
              setSelectedGroup(groups[0]);
            }}
            style={{
              ...(selectedClassNamesHaveEditsAvailable
                ? {
                    color: "rgb(231, 109, 26)",
                    backgroundColor: "white",
                    borderColor: "white",
                  }
                : {}),
              alignSelf: "flex-start",
              borderRadius: 50,
              cursor: selectedClassNamesHaveEditsAvailable ? "pointer" : "blocked",
            }}
            variant={"outlined"}
          >
            {selectedClassNamesHaveEditsAvailable ? (
              <TranslationWrapper tDefault={"Edit"} tKey={"live-interface.edit"} />
            ) : (
              <TranslationWrapper
                tDefault={"No modifications available here"}
                tKey={"live-interface.no-edits-available"}
              />
            )}
          </Button>
        ) : null}
      </div>
      <div
        onMouseEnter={() => {
          postMessageToIframe("addNewHoveredClass", { classInfo: hoverCard.hoveredValues[0] });
        }}
        onMouseLeave={() => {
          postMessageToIframe("removeNewHoveredClass", { classInfo: hoverCard.hoveredValues[0] });
        }}
      >
        <p style={{ margin: 0 }}>
          {contentDescription ? (
            <p
              style={{
                color: "white",
                maxWidth: "320px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {contentDescription ? contentDescription.toString() : null}
            </p>
          ) : null}
        </p>
      </div>
      <h5 style={{ color: "#222" }}>
        <TranslationWrapper tDefault={"Components"} tKey={"live-interface.hover-card.components"} />
      </h5>
      <div>
        {groups.map((group) => {
          return (
            <Box
              onClick={() => {
                setSelectedGroup(group);
              }}
              onMouseEnter={() => {
                postMessageToIframe("addNewHoveredClass", { classInfo: `.JS-${group}-Root` });
              }}
              onMouseLeave={() => {
                postMessageToIframe("removeNewHoveredClass", { classInfo: `.JS-${group}-Root` });
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.10)",
                },
                display: "grid",
                gridTemplateColumns: "1fr 32px",
                gap: 2,
                alignItems: "center",
                borderRadius: "4px",
                transition: "all 0.2s ease-in",
                marginBottom: "8px",
                cursor: "pointer",
              }}
            >
              <LabeledBadge
                badgeColor={{ backgroundColor: "#f07929" }}
                name={"Component"}
                params={{
                  style: {
                    justifyContent: "left",
                    cursor: "pointer",
                  },
                }}
                textColor={"rgba(0, 0, 0, 0.87) !important"}
                value={group}
              />
              <EditIcon fontSize={"small"} style={{ color: "rgba(0, 0, 0, 0.5)" }} />
            </Box>
          );
        })}
      </div>
    </div>
  );
}

export type JsClasses = [string, ...string[]];
